import _classCallCheck from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
export var UpploadEffect = function UpploadEffect() {
  _classCallCheck(this, UpploadEffect);

  this.type = "effect";
  this.name = "";
  this.invisible = false;
  this.noRecolor = false;
  this.color = "#000";
  this.icon = "";

  this.template = function () {
    return "";
  };

  this.handlers = function () {};

  this.supports = function () {
    return true;
  };
};